<template>
  <div>
    <v-layout class="mt-5 mb-2">
      <v-flex xs2 class="mr-3">
        <v-select
          v-model="buscarSelect"
          :items="buscaOptions"
          label="Tipo de busca"
          outlined
          menu-props="offsetY"
        ></v-select>
      </v-flex>
      <v-flex xs6>
        <v-autocomplete
          outlined
          v-model="pesquisa"
          :search-input.sync="searchBusca"
          :hide-no-data="!searchBusca && listaOptions.length === 0"
          :no-data-text="buscarLoading ? 'Carregando dados, aguarde...' : `Nenhuma opção encontrada com '${searchBusca}'`"
          :loading="buscarLoading"
          :items="listaOptions"
          hide-selected
          item-text="descricaocomposicaoalimentopadrao"
          item-value="identificadorcomposicaoalimentopadrao"
          label="Buscar por"
          placeholder="Digite um valor para buscar"
          prepend-inner-icon="search"
          return-object
          @keydown="handleBusca"
          :filter="filterData"
        >
          <!-- <template v-slot:item="{ item }">
            <div class="py-2" @click="selectBusca(item)">{{`${item.identificadorcomposicaoalimentopadrao} - ${item.descricaocomposicaoalimentopadrao}`}}</div>
          </template> -->
            <template v-slot:item="{ item }">
             <div class="py-2" @click="selectBusca(item)"> {{item.identificadorcomposicaoalimentopadrao}} - {{item.descricaocomposicaoalimentopadrao}}</div>
            </template>
            <template v-slot:selection="{ item }">
             <div> {{item.identificadorcomposicaoalimentopadrao}} - {{item.descricaocomposicaoalimentopadrao}} </div>
            </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadorcomposicaoalimentopadrao"
      :novo="novoComposicaoAlimentoPadrao"
      :editar="editarComposicaoAlimentoPadrao"
      :excluir="excluirComposicaoAlimentoPadrao"
      :cancelar="cancelarComposicaoAlimentoPadrao"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaComposicaoAlimentoPadrao">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <v-row no-gutters>
            <v-col  lg="6">
              <v-text-field  label="Código Composição Alimento Padrão" v-model="form.identificadorcomposicaoalimentopadrao" outlined disabled background-color="#f2f2f2"></v-text-field>
            </v-col>
          </v-row>

           <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.descricaocomposicaoalimentopadrao">
               <v-text-field
                :disabled="isFormDisabled"
                slot-scope="{ props }" v-bind="props"
                v-model="form.descricaocomposicaoalimentopadrao" :maxlength="100"
                label="Descrição Composição do Alimento Padrão*" outlined
                tabindex="-1"  >
                </v-text-field>
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.indicaorigemalimentoexterno">
                  <v-select
                  slot-scope="{ props }" v-bind="props"
                  label="Origem Alimento Externo"
                  :items="origemAlimentoExternoOptions"
                  v-model="form.indicaorigemalimentoexterno"
                  outlined
                  :disabled="acao == '' || acao == 'excluir'"
                ></v-select>
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.identificadoralimento">
                <v-autocomplete
                slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.identificadoralimento"
                  :items="alimentosOptions"
                  outlined
                  label="Identificador Alimento*"
                  :no-data-text="alimentosLoading ? 'Carregando dados, aguarde...' : form.alimentoSearch ? `Nenhuma opção encontrada com '${form.alimentoSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="form.alimentoSearch"
                  :disabled="isFormDisabled"
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  :loading="alimentosLoading"
                  loader-height="3"
                  @focus="loadAlimentosOptions"
                ></v-autocomplete>
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.quantidadeenergia">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadeenergia"
                  label="Quantidade Energia"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidadecarboidrato">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadecarboidrato"
                  label="Quantidade Carboidratos"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadegorduratotal">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadegorduratotal"
                  label="Quantidade Gordura Total"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadegordurapolisaturada">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadegordurapolisaturada"
                  label="Quantidade Gordura Polisaturada"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>

          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidadegorduramonosaturada">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadegorduramonosaturada"
                  label="Quantidade Gordura Monosaturada"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadegordurasaturada">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadegordurasaturada"
                  label="Quantidade Gordura Saturada"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadeproteina">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadeproteina"
                  label="Quantidade Proteína"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidadefibratotal">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadefibratotal"
                  label="Quantidade Fibra Total"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadefibrasoluvel">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadefibrasoluvel"
                  label="Quantidade Fibra Solúvel"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadefibrainsoluvel">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadefibrainsoluvel"
                  label="Quantidade Fibra Insolúvel"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidadecolesterol">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadecolesterol"
                  label="Quantidade Colesterol"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminaa">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminaa"
                  label="Quantidade Vitamina A"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminac">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminac"
                  label="Quantidade Vitamina C"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminab1">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminab1"
                  label="Quantidade Vitamina B1"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminab2">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminab2"
                  label="Quantidade Vitamina B2"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminab6">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminab6"
                  label="Quantidade Vitamina B6"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminab12">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminab12"
                  label="Quantidade Vitamina B12"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminad">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminad"
                  label="Quantidade Vitamina D"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminab3">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminab3"
                  label="Quantidade Vitamina B3"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminab9">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminab9"
                  label="Quantidade Vitamina B9"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminab5">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminab5"
                  label="Quantidade Vitamina B5"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadevitaminae">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadevitaminae"
                  label="Quantidade Vitamina E"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidadeiodo">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadeiodo"
                  label="Quantidade Iodo"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadesodio">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadesodio"
                  label="Quantidade Sódio"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadecalcio">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadecalcio"
                  label="Quantidade Cálcio"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidademagnesio">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidademagnesio"
                  label="Quantidade Magnésio"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadezinco">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadezinco"
                  label="Quantidade Zinco"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidademanganes">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidademanganes"
                  label="Quantidade Manganês"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidadepotassio">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadepotassio"
                  label="Quantidade Potássio"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadefosforo">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadefosforo"
                  label="Quantidade Fósforo"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadeferro">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadeferro"
                  label="Quantidade Ferro"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters style="gap: 5px;">
            <v-col lg="2">
              <Validate :v="$v.form.quantidadecobre">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadecobre"
                  label="Quantidade Cobre"
                  slot-scope="{ props }" v-bind="props"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
            <v-col lg="2">
              <Validate :v="$v.form.quantidadeselenio">
                <v-text-field
                  v-mask="['#.#####', '##.#####', '###.#####', '####.#####', '#####.#####', '######.#####', '#######.#####', '########.#####', '#########.#####']"
                  v-model="form.quantidadeselenio"
                  slot-scope="{ props }" v-bind="props"
                  label="Quantidade Selênio"
                  outlined
                  :disabled="isFormDisabled"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.identificadorgrupoalimentomerenda">
                <v-autocomplete
                slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.identificadorgrupoalimentomerenda"
                  :items="grupoMerendaOptions"
                  outlined
                  label="Grupo de Alimento"
                  :no-data-text="grupoMerendaLoading ? 'Carregando dados, aguarde...' : form.grupoMerendaSearch ? `Nenhuma opção encontrada com '${form.grupoMerendaSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="form.grupoMerendaSearch"
                  :disabled="isFormDisabled"
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  :loading="grupoMerendaLoading"
                  loader-height="3"
                  @focus="loadGrupoMerendaOptions"
                  @change="loadGrupoMerendaOptions"
                ></v-autocomplete>
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.descricaocomumalimento">
                <v-text-field  slot-scope="{ props }" v-bind="props" v-model="form.descricaocomumalimento" label="Descrição Comum Alimento" outlined  :disabled="isFormDisabled" maxlength="45" ></v-text-field>
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.unidadecomumalimento">
                <v-text-field   slot-scope="{ props }" v-bind="props" v-model="form.unidadecomumalimento" label="Unidade Comum Alimento" outlined  :disabled="isFormDisabled" maxlength="15" ></v-text-field>
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.fatortransformacaounidade">
                <v-text-field type="number" slot-scope="{ props }" v-bind="props" v-model="form.fatortransformacaounidade" label="Fator Transformação Unidade" outlined  :disabled="isFormDisabled"></v-text-field>
              </Validate>
            </v-col>
          </v-row>


        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import string from '../../utils/string';
import { required, integer, maxLength, decimal } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const DepositoGeralSMAERepository = RepositoryFactory.get("depositoGeralSMAERepository");
const ComposicaoAlimentoPadraoRepository = RepositoryFactory.get("composicaoAlimentoPadrao");
const GrupoAlimentoMerendaRepository = RepositoryFactory.get("grupoAlimentoMerenda");

export default {
  name: 'ComposicaoAlimentoPadrao',
  data() {
    return {
      // filterData: autocomplete.filterData,
      pesquisa: '',
      items: [],
      acao: '',
      form: this.setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaocomposicaoalimentopadrao',
      buscaOptions: [
        { value: 'identificadorcomposicaoalimentopadrao', text: 'Identificador Composição' },
        { value: 'descricaocomposicaoalimentopadrao', text: 'Descrição Composição Alimento' },
      ],
      alimentosLoading: false,
      alimentosOptions: [],
      formUltimo: {},
      textoBusca: '',
      searchBusca: '',
      listaOptions: [],
      buscarLoading: false,
      origemAlimentoExternoOptions: [
        'TACO v.II ',
        'TBCA',
        'PHILIPPI',
        'McCance'
      ],
      grupoMerendaOptions: [],
      grupoMerendaLoading: false,
    };
  },
  watch: {
    'form.alimentoSearch'(newVal, oldVal) {
      const novoValor = newVal ?? ''
      if(novoValor.length < 3) return
      clearTimeout(this._searchTimeId)
      this._searchTimeId = setTimeout(async () => {
                                                    await this.loadAlimentosOptions()
                                                  }, 1000
                                    )
    },

  },
  computed: {
    ...mapGetters(['school']),
    isFormDisabled() {
      return this.acao == '' || this.acao == 'excluir'
    },
  },
  validations: {
    form: {
      identificadorcomposicaoalimentopadrao : { integer },
      descricaocomposicaoalimentopadrao: { required },
      indicaorigemalimentoexterno: { maxLength: maxLength(11) },
      identificadoralimento: { integer },
      quantidadecarboidrato: { decimal, maxLength: maxLength(11) },
      quantidadegorduratotal: { decimal, maxLength: maxLength(11) },
      quantidadegordurapolisaturada: { decimal, maxLength: maxLength(11) },
      quantidadegorduramonosaturada: { decimal, maxLength: maxLength(11) },
      quantidadegordurasaturada: { decimal, maxLength: maxLength(11) },
      quantidadeproteina: { decimal, maxLength: maxLength(11) },
      quantidadefibratotal: { decimal, maxLength: maxLength(11) },
      quantidadefibrasoluvel: { decimal, maxLength: maxLength(11) },
      quantidadefibrainsoluvel: { decimal, maxLength: maxLength(11) },
      quantidadecolesterol: { decimal, maxLength: maxLength(11) },
      quantidadevitaminaa: { decimal, maxLength: maxLength(11) },
      quantidadevitaminac: { decimal, maxLength: maxLength(11) },
      quantidadevitaminab1: { decimal, maxLength: maxLength(11) },
      quantidadevitaminab2: { decimal, maxLength: maxLength(11) },
      quantidadevitaminab6: { decimal, maxLength: maxLength(11) },
      quantidadevitaminab12: { decimal, maxLength: maxLength(11) },
      quantidadevitaminad: { decimal, maxLength: maxLength(11) },
      quantidadevitaminab3: { decimal, maxLength: maxLength(11) },
      quantidadevitaminab9: { decimal, maxLength: maxLength(11) },
      quantidadevitaminab5: { decimal, maxLength: maxLength(11) },
      quantidadevitaminae: { decimal, maxLength: maxLength(11) },
      quantidadeiodo: { decimal, maxLength: maxLength(11) },
      quantidadesodio: { decimal, maxLength: maxLength(11) },
      quantidadecalcio: { decimal, maxLength: maxLength(11) },
      quantidademagnesio: { decimal, maxLength: maxLength(11) },
      quantidadezinco: { decimal, maxLength: maxLength(11) },
      quantidademanganes: { decimal, maxLength: maxLength(11) },
      quantidadepotassio: { decimal, maxLength: maxLength(11) },
      quantidadefosforo: { decimal, maxLength: maxLength(11) },
      quantidadeferro: { decimal, maxLength: maxLength(11) },
      quantidadecobre: { decimal, maxLength: maxLength(11) },
      quantidadeselenio: { decimal, maxLength: maxLength(11) },
      identificadorgrupoalimentomerenda: { integer },
      descricaocomumalimento: { maxLength: maxLength(45) },
      unidadecomumalimento: { maxLength: maxLength(15) },
      fatortransformacaounidad: { integer },

    },
  },
  async mounted() {
    this.$Progress.finish();
  },
  methods: {
    setFormInicial() {
      return ({
        alimentoSearch: '',
        grupoMerendaSearch: '',
        identificadorcomposicaoalimentopadrao : '',
        descricaocomposicaoalimentopadrao: '',
        indicaorigemalimentoexterno: '',
        identificadoralimento: '',
        quantidadecarboidrato: '',
        quantidadegorduratotal: '',
        quantidadegordurapolisaturada: '',
        quantidadegorduramonosaturada: '',
        quantidadegordurasaturada: '',
        quantidadeproteina: '',
        quantidadefibratotal: '',
        quantidadefibrasoluvel: '',
        quantidadefibrainsoluvel: '',
        quantidadecolesterol: '',
        quantidadevitaminaa: '',
        quantidadevitaminac: '',
        quantidadevitaminab1: '',
        quantidadevitaminab2: '',
        quantidadevitaminab6: '',
        quantidadevitaminab12: '',
        quantidadevitaminad: '',
        quantidadevitaminab3: '',
        quantidadevitaminab9: '',
        quantidadevitaminab5: '',
        quantidadevitaminae: '',
        quantidadeiodo: '',
        quantidadesodio: '',
        quantidadecalcio: '',
        quantidademagnesio: '',
        quantidadezinco: '',
        quantidademanganes: '',
        quantidadepotassio: '',
        quantidadefosforo: '',
        quantidadeferro: '',
        quantidadecobre: '',
        quantidadeselenio: '',
        identificadorgrupoalimentomerenda: '',
        descricaocomumalimento: '',
        unidadecomumalimento: '',
        fatortransformacaounidad: '',
      })

    },
    handleBusca() {
      const novoValor = this.searchBusca ?? ''
        if(novoValor.length < 1) return
      clearTimeout(this._searchTimeId)
      this.listaOptions = []
      this._searchTimeId = setTimeout(async () => {
                                                    await this.listarRegistros()
                                                  }, 1000
                                    )
    },
    async listarRegistros() {
      try {

        this.buscarLoading = true
        const { data } = await ComposicaoAlimentoPadraoRepository.buscarComposicoesAlimentoPadrao({
          [this.buscarSelect]: this.searchBusca
        })
        this.listaOptions = data.results.map( a => {
          return {
            ...a,
          }
        })
      } catch (error) {
        console.error(error)
      }
      finally {
        this.buscarLoading = false

      }
    },

    preencheCampoAlimento(identificadoralimento, descricaoalimentosmar) {
      this.form.identificadoralimento = identificadoralimento
      this.alimentoSearch = descricaoalimentosmar

      this.alimentosOptions.push({
        text: descricaoalimentosmar,
        value: identificadoralimento
      })
    },


    selectBusca(item) {
      this.form = item

      if(item.deposito_geral_s_m_a_e.descricaoalimentosmar) {
        this.alimentosOptions.push({
          text: item.deposito_geral_s_m_a_e.descricaoalimentosmar,
          value: this.form.identificadoralimento,
        })
      }

      if (item.grupo_alimento_merenda) {
          this.grupoMerendaOptions.push({
            text: item.grupo_alimento_merenda.descricaogrupoalimentomerenda,
            value: this.form.identificadorgrupoalimentomerenda,
          })
      }

      this.listaOptions = []
      this.searchBusca = ''
      this.textoBusca = ''

    },
    tabelaComposicaoAlimentoPadrao() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Composição Alimento Padrão/ Listar',
          rota_api: `merenda/composicao-alimento-padrao/tabela`,
          headers: [{ text: 'Identificador', value: 'identificadorcomposicaoalimentopadrao', sortable: false },
                    { text: 'Composição Padrão Alimento', value: 'descricaocomposicaoalimentopadrao', sortable: false },
                  ],
        },
      });
    },
    novoComposicaoAlimentoPadrao() {
      this.acao = 'novo';
      this.form = this.setFormInicial();
      this.$v.$reset();
    },
    editarComposicaoAlimentoPadrao() {
      this.acao = 'editar';
    },
    cancelarComposicaoAlimentoPadrao() {
      if (this.acao == 'novo') {
        this.form = this.setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirComposicaoAlimentoPadrao() {
      this.acao = 'excluir';

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta composição de alimento padrão?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await ComposicaoAlimentoPadraoRepository.deletarComposicaoAlimentoPadrao(this.form.identificadorcomposicaoalimentopadrao);

          this.submitText = data.message;
          this.snackbar = true;
          this.form = this.setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.acao = '';
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        const { data } = await ComposicaoAlimentoPadraoRepository[this.acao === 'novo' ? 'criarComposicaoAlimentoPadrao' : 'editarComposicaoAlimentoPadrao'](this.form);

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.formUltimo = { ...this.form };

        if(data.results)  {
          const { identificadoralimento, descricaoalimentosmar } = data.results.deposito_geral_s_m_a_e
           this.preencheCampoAlimento(identificadoralimento, descricaoalimentosmar)

        }

      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }

      this.$v.$reset();
    },
    encontrado(dados) {
      this.form = this.setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...dados };
      this.$refs.buscaSimpleApi.lista = [];
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },

    async loadAlimentosOptions() {
      this.alimentosLoading = true
      const { data } = (this.form.alimentoSearch) ? await DepositoGeralSMAERepository.buscarDepositoDaEscola({
                                                                                                              descricaoalimentosmar: this.form.alimentoSearch ?? ''
                                                                                                            })
                                                  : await DepositoGeralSMAERepository.buscarDepositoDaEscola()
      for (const key of data.results) {
        this.alimentosOptions.push({ value: key.identificadoralimento, text: `${key.codigoalimentosmar} - ${key.descricaoalimentosmar}`, medida: key.unidademedidaalimento })
      }
      this.alimentosLoading = false
    },

    async loadGrupoMerendaOptions() {
      this.grupoMerendaLoading = true
      this.grupoMerendaOptions = []
      const { data } = (this.form.grupoMerendaSearch) ? await GrupoAlimentoMerendaRepository.buscarGruposAlimentoMerenda({
                                                                                                              descricaogrupoalimentomerenda: this.form.grupoMerendaSearch ?? ''
                                                                                                            })
                                                  : await GrupoAlimentoMerendaRepository.buscarGruposAlimentoMerenda()
      for (const key of data.results) {
        this.grupoMerendaOptions.push({ value: key.identificadorgrupoalimentomerenda, text: key.descricaogrupoalimentomerenda })
      }
      this.grupoMerendaLoading = false
    },
    filterData(item, queryText, itemText) {
      const maiusculoESemAcento = string.removerAcentos(queryText).toUpperCase()
      const itemCerto = item.descricaocomposicaoalimentopadrao.includes(maiusculoESemAcento)
      return itemCerto ? item : {}
    }


  },
};
</script>

<style>

</style>
